import {
  always,
  visitNumberIs
} from "./question-conditions";

// display: <condition function>   decides when the question is displayed in start encounter
// post: <condition function>  decides when the question needs to be posted to backend,
// usually this is just the visit numbers in which the question can be asked
// note - questions that need to be posted but are not displayed will be posted as NULL

const clinicalAssessment = [
  // {
  //   key: 'NEW_DIAGNOSIS',
  //   defaultValue: null,
  //   display: visitNumberIs(1,2,3,4,5),
  //   post: visitNumberIs(1,2,3,4,5)
  // },
  {
    key: 'DIABETES_MELLITUS_TYPE1',
    display: always,
    post: always,
  },
  {
    key: 'DIABETES_MELLITUS_TYPE2',
    display: always,
    post: always,
  },
  {
    key: 'CHRONIC_KIDNEY_DISEASE',
    display: always,
    post: always,
  },
  {
    key: 'HYPERTENSION',
    display: always,
    post: always,
  },
  {
    key: 'CEREBROVASCULAR_DISEASE',
    display: visitNumberIs(1),
    post: visitNumberIs(1)
  },
  {
    key: 'STROKE',
    display: always,
    post: always,
  },
  {
    key: 'TIA',
    display: always,
    post: always,
  },
  {
    key: 'CAROTID_ENDARTERECTOMY',
    display: always,
    post: always,
  },
  {
    key: 'PERIPHERAL_ARTERY_DISEASE',
    display: always,
    post: always,
  },
  {
    key: 'THROMBOEMBOLISM',
    display: always,
    post: always
  },
  {
    key: 'NEW_DIAGNOSIS_HF',
    display: always,
    post: always
  },
  {
    key: 'AGE',
    display: visitNumberIs(6,7),
    post: visitNumberIs(6,7),
  },
  {
    key: 'CHA2DS2_VASC',
    display: visitNumberIs(6,7),
    post: visitNumberIs(6,7),
  },
];

export default clinicalAssessment;